module.exports = __webpack_public_path__ + "static/media/SAF-MARINE.1ae3c487.svg";